import { render, staticRenderFns } from "./MaxVP.vue?vue&type=template&id=1a4d9a4e&scoped=true"
import script from "./MaxVP.vue?vue&type=script&lang=js"
export * from "./MaxVP.vue?vue&type=script&lang=js"
import style0 from "./MaxVP.vue?vue&type=style&index=0&id=1a4d9a4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d9a4e",
  null
  
)

export default component.exports